<template>
  <div class="page">
    <page-builder
      :initial-content="content"
      :show-toolbar="true"
      :text-only="false"
      @change="handleContentChange"
      @save="handleSave"
    />
  </div>
</template>

<script>
import PageBuilder from '../components/PageBuilder.vue'

export default {
  components: {
      PageBuilder
  },
  data() {
    return {
      content: ''
    }
  },
  created(){
    this.content = '<div><h1>888欢迎使用</h1><p>点击文本开始编辑</p></div>'
  },
  mounted () {
      //this.fetchData()
      //this.content = '<div><h1>888欢迎使用</h1><p>点击文本开始编辑</p></div>'
  },
  methods: {
    handleContentChange(newContent) {
      console.log('内容已更改:', newContent)
    },
    handleSave(content) {
      console.log('保存内容:', content)
      // 这里可以调用API保存内容
    }
  }
}
</script>

<style>
.page {
  padding: 40px 20px 20px;
}

.gjs-cv-canvas {
  width: 100% !important;
  height: calc(100%) !important;
  top: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Previewreport.vue